import * as React from 'react';
import AddModuleComponent from './AddModuleComponent';

export default class ModuleComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
     
        this.updateModule = this.updateModule.bind(this);
        this.saveModule = this.saveModule.bind(this);
        this.redirectTo = this.redirectTo.bind(this);
    }

    updateModule(data: any) {
        this.props.updateModule(data);
    }
  
    saveModule() {
        this.props.saveModule();
    }

    redirectTo(data: any) {
        console.log("Data",data);
        this.props.path(data);
    }
    
    render() {
        return (
            <>
                <AddModuleComponent
                    moduleId ={this.props.moduleId}
                    updateEditModuleMetadata={this.props.updateEditModuleMetadata}
                    editModuleMetadata={this.props.editModuleMetadata} 
                    createUpdateModule={this.updateModule} 
                    saveModule ={this.saveModule}
                    redirect={this.redirectTo}
                    isModuleLocked ={this.props.isModuleLocked}

                />                
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/ModuleComponent.tsx